
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';

import App from './App';
import HomePage from './HomePage';
import LoggedPage from './auth/LoggedPage';
import LoginPage from './auth/LoginPage';
import LogoutPage from './auth/LogoutPage';
import NoAccessPage from './NoAccessPage';
import ProjectMapPage from './projectMapPage/ProjectMapPage';
import ProjectOverviewPage from './projectOverviewPage/ProjectOverviewPage';
import ProjectListPage from './projectListPage/ProjectListPage';
import Routes from './Routes';

const routes = [
    {
        component: App,
        routes: [{
            path: '/login',
            component: LoginPage
        }, {
            path: '/logout',
            component: LogoutPage
        }, {
            path: '/noaccess',
            component: NoAccessPage
        }, {
            component: LoggedPage,
            routes: [{
                path: '/',
                exact: true,
                component: HomePage
            }, {
                path: '/projectview/:id',
                component: ProjectOverviewPage
            }, {
                path: '/projectmap/:id',
                component: ProjectMapPage
            }, {
                path: '/projectlist',
                component: ProjectListPage
            }]
        }]
    }
];

const AppRouter = () => {
    return (
        <Router>
            <Routes routes={routes} />
        </Router>
    );
}

export default AppRouter;
